<template>
  <w-icon-wrapper icon-name='work-color-selection-icon'>
    <g
      id="_85_Farbauswahl_Icon"
      data-name="85 Farbauswahl_Icon"
      transform="translate(26.637 0.041)"
    >
      <path
        id="Pfad_55830"
        data-name="Pfad 55830"
        d="M-8.426,11.514-14.387.764a1.565,1.565,0,0,0-1.37-.805,1.565,1.565,0,0,0-1.368.805l-5.961,10.75a8.305,8.305,0,0,0,.108,8.317,8.306,8.306,0,0,0,7.221,4.128,8.307,8.307,0,0,0,7.221-4.128A8.305,8.305,0,0,0-8.426,11.514Zm-1.808,7.316a6.352,6.352,0,0,1-5.522,3.157,6.35,6.35,0,0,1-5.522-3.158,6.346,6.346,0,0,1-.083-6.359l5.6-10.111,5.6,10.111A6.348,6.348,0,0,1-10.234,18.831Z"
        transform="translate(1.514)"
        fill="currentColor"
      />
      <path
        id="Pfad_55831"
        data-name="Pfad 55831"
        d="M-17.565,13.351a1,1,0,0,0-.282-1.38,1,1,0,0,0-1.386.277,5.743,5.743,0,0,0,1.125,7.262,1,1,0,0,0,.707.293,1,1,0,0,0,.707-.293,1,1,0,0,0,0-1.414C-19.011,15.778-17.722,13.6-17.565,13.351Z"
        transform="translate(1.766 -0.249)"
        fill="currentColor"
      />
      <rect
        id="Rechteck_4044"
        data-name="Rechteck 4044"
        width="24"
        height="24"
        transform="translate(-26.637 -0.041)"
        fill="none"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconColorSelection' };
</script>
